import _ from "lodash";
import { message } from "antd";

const statusMapText = (status_label, status, notes) => {
  if (status_label === "Appraisal") {
    if (status === "Dalam Proses") {
      return "Unassigned";
    } else if (status === "Batal") {
      return "Cancel";
    } else {
      return "Assigned";
    }
  } else {
    return "Assigned";
  }
};

const number_format = (number, decimals, dec_point, thousands_sep) => {
  let n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    toFixedFix = function (n, prec) {
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      let k = Math.pow(10, prec);
      return Math.round(n * k) / k;
    },
    s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
};

const getCarName = (carDetail) => {
  const brand = _.find(carDetail, { fieldName: "Brand" });
  const tipe = _.find(carDetail, { fieldName: "Tipe" });
  const year = _.find(carDetail, { fieldName: "Tahun" });
  return `${brand ? brand.value : ""} ${tipe ? tipe.value : ""} ${
    year ? year.value : ""
  }`;
};

const formatRupiah = (number) => {
  let data;
  if (number) {
    if (number !== "N/A") {
      data = `Rp. ${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")},-`;
    } else {
      data = number;
    }
  } else {
    data = `Rp.0,-`;
  }
  return data;
};

const getIntegerValueByKey = (payload, stringObj) => {
  return parseInt(_.get(payload, stringObj)) || 0;
};

const getFloatValueByKey = (payload, stringObj) => {
  return parseFloat(_.get(payload, stringObj)) || 0;
};

const formatNumber = (number) => {
  let data = null;
  if (number) {
    data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  return data;
};

const backFormatRupiah = (number) => {
  let data;
  if (number) {
    if (number !== "N/A") {
      data = number.replace(/\./g, "");
    } else {
      data = number;
    }
  } else {
    data = `0`;
  }
  return data;
};

const errorMessage = (e) => {
  if (typeof e.data === "string") {
    message.error(e.data);
  } else {
    message.error(
      (e.data ? e.data.message : e.message) || "Something when wrong!"
    );
  }
};

export {
  statusMapText,
  number_format,
  getCarName,
  formatRupiah,
  backFormatRupiah,
  formatNumber,
  errorMessage,
  getIntegerValueByKey,
  getFloatValueByKey,
};



// WEBPACK FOOTER //
// src/components/Utils/index.js